import { useEffect, useRef, useState } from "react";

// 지문 낭독 음원(지인에듀가 지문마다 만들어 주는 mp3, 2026-10-16). '전체 본문' 머리줄 오른쪽에 둔다.
// 종이 시험지에서 QR 이 지문 오른쪽 위에 찍히는 것과 같은 자리다. 속도는 playbackRate 로만 바꾼다.
const SPEED_LIST = [0.8, 1, 1.2];

const PassageAudioButton = ({ audioUrl, accentColor = "#E8920A" }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [speed, setSpeed] = useState(1);

  useEffect(() => {
    setIsPlaying(false);
    if (audioRef.current) audioRef.current.pause();
  }, [audioUrl]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.playbackRate = speed;
  }, [speed]);

  if (!audioUrl) return null;

  const toggle = (event) => {
    event.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.playbackRate = speed;
      audio.play().catch(() => setIsPlaying(false));
    } else {
      audio.pause();
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", letterSpacing: 0 }}>
      <audio
        ref={audioRef}
        src={audioUrl}
        preload="none"
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      />
      {SPEED_LIST.map((one) => (
        <button
          type="button"
          key={one}
          onClick={(event) => {
            event.stopPropagation();
            setSpeed(one);
          }}
          style={{
            border: "none",
            background: "transparent",
            padding: "2px 4px",
            fontFamily: "inherit",
            fontSize: "11px",
            fontWeight: 800,
            color: speed === one ? accentColor : "#B7C2C9",
            cursor: "pointer",
          }}
        >
          {one}x
        </button>
      ))}
      <button
        type="button"
        onClick={toggle}
        aria-label={isPlaying ? "멈춤" : "듣기"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          height: "26px",
          padding: "0 10px",
          border: "none",
          borderRadius: "999px",
          background: isPlaying ? accentColor : "#0E141B",
          color: "#FFFFFF",
          fontFamily: "inherit",
          fontSize: "12px",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        {isPlaying ? "❚❚ 멈춤" : "▶ 듣기"}
      </button>
    </span>
  );
};

export default PassageAudioButton;
